import { EntLivestockTradeActivity } from "./models/organic/livestockTradeActivity";

/**
 * Contains all paths used in the application
 *
 * @constant
 * @type {Object}
 */
export const Paths = {
  mainadminpage: '/main-admin-page',
  home: '/',
  login: '/admin-panel/login',
  changepasswordpage: '/changepasswordpage',
  roles: '/role',
  changePassword: '/change-password',
  users: '/user',
  kurultairegister: '/kurultai-register',
  farmowners: '/farmowners',
  components: '/components',
  locations: '/locations',
  populations: '/populations',
  products: '/products',
  reservoirs: '/reservoir-register',
  breedingfarms: '/breedingfarms',
  reservoirshistory: '/reservoir-history',
  agroculturalcooperative: '/departments/mechanization/agricultural-cooperatives',

  handbooks: {
	index: '/handbooks',
	mechanization: '/handbooks/mechanization',
	realty: '/handbooks/realty',
	transport: '/handbooks/transport',
	farming: '/handbooks/farming',
	coate: '/handbooks/coate',
	organizationelements: '/handbooks/organizationelements',
	parameters: '/handbooks/parameters',
	chemicalization: '/handbooks/chemicalization',
	veterinary: '/handbooks/veterinary',
	kurultai: '/handbooks/kurultai',

	economicactivitytypes: '/departments/mechanization/hb-economic-activity',
	leasingoperator: '/departments/mechanization/hb-leasing-operator',
	entitytypes: '/departments/mechanization/hb-organizational-legal-form',
	leasingproject: '/departments/mechanization/hb-leasing-project',

	ownership: '/handbooks/realty/ownership',
	ownershiptypes: '/hb-real-estate-ownership-type',
	realestatelangcategories: '/hb-real-estate-lang-categories',
	typeestatepurposeobject: '/hb-real-estate-purpose-objects',
	typeobject: '/hb-real-estate-type-objects',
	realestateconditions: '/hb-real-estate-conditions',
	ownershipforms: '/departments/mechanization/hb-mts-ownership-forms',
	typetransport: '/hb-transport-type',
	transportcategory: '/hb-transport-category',
	transportstatus: '/hb-transport-status',
	hbstorageroute: '/hb-storage-types',
	storageregister: 'departments/organic/storage-register',


	questionCategoryType: '/kurultai/hb-question-category',
	executionStatusType: '/kurultai/hb-execution-status',

	breedingFarmStatuses: '/hb-breeding-farms-status',
	animalbreedfarmtypes: '/hb-breeding-farms-type',
	typeanimal: '/hb-animal-type',
	typeproduct: '/hb-product-type',
	generalProductCategory: '/hb-product-category',
	animalbreed: '/hb-animal-breed',
	direction: '/hb-direction',

	territorialunits: '/hb-territorial-unit',

	positions: '/hb-positions',
	departments: '/hb-departments',
	governments: '/hb-governments',

	unitmeasurement: '/hb-unit-measurement',

	types_of_fertilizers: '/departments/chemicalization/hb-fertilizer-type',
	filter_fertilizer_category: '/departments/chemicalization/hb-fertilizer-category',
	typesOfPesticides: '/departments/chemicalization/hb-pesticides-type',
	typesOfAgriculturalCrops: '/departments/chemicalization/hb-crop-type',
	typeOfCategoryProduct: '/departments/chemicalization/hb-product-category',
	typeOfProduct: '/departments/chemicalization/product',

	typeOfVeterinaryCategoryProduct: '/departments/veterinary/hb-product-category',
	typeOfVeterinaryProduct: '/departments/veterinary/hb-product',

	certificate: '/hb-certificate',
	checkpoint: 'hb-checkpoint',
	industryType: '/hb-industry-type',
	legalForm: '/hb-legal-form',
	registerStatus: '/hb-register-status',
	seasonality: '/hb-seasonality',
	serviceType: '/hb-service-type',
	transportAccess: '/hb-transport-access',

	farmCategory: '/departments/organic/hb-farm-category',
	rawMaterial: '/hb-raw-material',
	citizenship: '/hb-citizenship',
	productionMethods: '/departments/organic/hb-production-methods',
	storageTypes: '/departments/organic/hb-storage-types',
  },

  chemicalization: {
	// fertilizer_sypply: '/chemicalization/availability_of_fertilizers',
	// fertilizer_needs: '/chemicalization/fertilizer_needs',
	// fertiliser: '/chemicalization/fertiliser',
	company: '/departments/chemicalization/company',
	register_of_pesticides: '/departments/chemicalization/pesticide-register',
	company_warehouses: '/departments/chemicalization/warehouse',
	stock: '/departments/chemicalization/stock',
	fertilizer_usage: '/departments/chemicalization/fertilizer-usage',
	winterCerealFertilizer: '/departments/chemicalization/winter-cereal-fertilizer',
	fertilizationcereals: 'departments/chemicalization/fertilizationcereals',
	pesticideRegister: '/departments/chemicalization/pesticide-register',
	pesticidespage: '/departments/chemicalization/pesticidespage',
  },

  veterinary: {
	index: '/veterinary',
	vetTransaction: '/departments/veterinary/transaction',
  },
  //   reservoir: {
  // 	  index: '/reservoir-register',
  // 	  history: '/reservoir-history',
  // 	  report: '/reservoir-report',
  //   },

  mechanization: {
	index: '/mechanization',
	info: '/departments/mechanization/info',
	totalaccount: '/real-estate/total-account',
	agroculturalmachineryusage: '/mechanization/agroculturalmachineryusage',
	leasingregister: '/departments/mechanization/leasing-register',
	mts: '/departments/mechanization/mts-register',
	reportdepartmentmech: '/reportdepartmentmech',
	transport: '/departments/mechanization/agricultural-machinery-register',
  },
  organic: {
	grossproductioncooperative: '/departments/organic/livestock-gross-production-yield',
	processingCapacity: '/departments/organic/processing-capacity-register',
	livestockTradeActivity: '/departments/organic/livestock-trade-activity',
	animalRegister: '/departments/organic/animal-register',
	tradeRegistry: '/departments/organic/trade-registry',
	theNeedsOfthePopulation: '/departments/organic',
	processingCompaniesadmin: '/departments/organic/processing-companies',
	storage: '/departments/organic/storage-registers',
	logisticsCenter: '/departments/organic/logistics-center',
	organicproducers: '/departments/organic/producers',
  },
  registries: {
	index: '/registries',
	personel: '/personnel-register',
	realestateregister: '/real-estate-register',
	financialindicators: '/financial-indicators-register',
	movableProperty: '/register-movable-property',
  },
  objects: '/objects',
  mapAndStatistics: '/mapAndStatistics',
  animal: '/animal',
  animalsale: '/animalsale',
  animalkrc: '/animalkrc',
  plantsales: '/plantsales',
  plantsproductions: '/plantsproductions',
  nursery: '/nursery',
  suppliers: '/suppliers',
  breedinplants: '/breedinplants',
  breedinfarms: '/breedinfarms',
  economicactivity: '/economicactivity',
  camera: '/camera',
  allcharts: '/allcharts',
  personal: '/personal',
  movable: '/movable',
  finance: '/finance',
  immovable: '/immovable',
  generaldata: '/generaldata',
  mts: '/mts',
  cooperatives: '/cooperatives',
  tls: '/tls',
  agriculturalmachinery: '/agriculturalmachinery',
  leasing: '/leasing',
  kurultai: '/kurultai',
  mineralfertilizersuppliers: '/mineralfertilizersuppliers',
  feeding: '/feeding',
  heatmap: '/heatmap',
  heatmapbytypesofproducts: '/heatmapbytypesofproducts',
  processingcapacities: '/processingcapacities',
  tlcorganic: '/tlcorganic',
  needsofthepopulation: '/needsofthepopulation',
  storageanalitical: '/storageanalitical',
  largeprocessors: '/largeprocessors',
  importexport: '/importexport',
  treePlusTwo: '/treePlusTwo',
  graphPirog: '/graphPirog',
  summaryData: '/summaryData',
  animalData: '/animalData',
}
